<template>
	<section>
		<div class="header-row">
			<h2>Actieve login sessies</h2>
			<Button @click="logoutAll()" type="button" v-if="sessions.length !== 0">Overal uitloggen</Button>
		</div>
		<table>
			<thead>
				<tr>
					<th>Apparaat</th>
					<th>Browser</th>
					<th>IP-adres</th>
					<th>Ingelogd op</th>
					<th>Ingelogd tot</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="session in sessions" :key="session.id">
					<td>{{ session.device }}</td>
					<td>{{ session.browser }}</td>
					<td>{{ session.ip_address }}</td>
					<td>{{ session.created_at }}</td>
					<td>{{ session.valid_until }}</td>
					<td class="action-cell">
						<Button type="button" @click="logout(session.id)">Uitloggen</Button>
					</td>
				</tr>
			<div v-if="sessions.length === 0">Gebruiker is nergens ingelogd.</div>
			</tbody>
		</table>
	</section>
</template>
<script>
import {client} from "@/store";

export default {
	props: {
		userId: {
			type: Number,
			required: true,
		}
	},
	data() {
		return {
			sessions: [],
		};
	},
	watch: {
		userId() {
			this.getSessions();
		}
	},
	mounted() {
		this.getSessions();
	},

	methods: {
		getSessions() {
			client.query(`
				query($userId: Int!) {
					loginSessions(userId: $userId) {
						id
						created_at
						valid_until
						browser
						device
						ip_address
					}
				}
			`, {
				userId: this.userId,
			}).then((data) => {
				this.sessions = this.parseRows(data.loginSessions);
			});
		},

		parseRows(rows) {
			return rows.map((row) => {
				return {
					id: row.id,
					created_at: this.isoDateToLocal(row.created_at),
					valid_until: this.isoDateToLocal(row.valid_until),
					browser: row.browser,
					device: row.device,
					ip_address: row.ip_address,
				};
			});
		},

		isoDateToLocal(isoDate) {
			isoDate = isoDate.replace(' ', 'T') + 'Z';
			const date = new Date(isoDate);
			return date.toLocaleString('nl-NL');
		},

		logout(sessionId) {
			client.query(`
				mutation($id: ID!) {
					invalidateLoginSession(id: $id)
				}
			`, {
				id: sessionId,
			}).then((result) => {
				if(result.invalidateLoginSession === 'SUCCESS') {
					this.$notify({
						group: "app",
						title: "Uitgelogd",
						type: "success",
						text: `De gebruikers sessie is succesvol beëindigd`,
					});
				} else if (result.invalidateLoginSession === 'ALREADY_INVALIDATED') {
					this.$notify({
						group: "app",
						title: "Fout",
						type: "error",
						text: `De gebruikers sessie is al beëindigd.`,
					});
				} else {
					this.$notify({
						group: "app",
						title: "Fout",
						type: "error",
						text: `Er is een fout opgetreden bij het beëindigen van de gebruikers sessie.`,
					});
				}
				this.getSessions();
			});
		},
		logoutAll() {
			client.query(`
				mutation($userId: ID!) {
					invalidateAllLoginSessions(userId: $userId)
				}
			`, {
				userId: this.userId,
			}).then((result) => {
				if(result.invalidateAllLoginSessions === 'SUCCESS') {
					this.$notify({
						group: "app",
						title: "Uitgelogd",
						type: "success",
						text: `Alle gebruikers sessies zijn succesvol beëindigd`,
					});
				} else {
					this.$notify({
						group: "app",
						title: "Fout",
						type: "error",
						text: `Er is een fout opgetreden bij het beëindigen van de gebruikers sessies.`,
					});
				}
				this.getSessions();
			});
		},
	},
}
</script>
<style scoped lang="scss">
	.header-row {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-top: 2px solid #f9f9f9;

		h2 {
			margin: 16px 0;
		}
	}

	Button {
		background-color: #d3455b;
		color: #ffffff;
		height: 40px;
		margin: 16px 0 16px 16px;
		text-align: center;
		border-radius: 5px;
		box-shadow: 0 2px 1px -2px rgba(0, 0, 0, 0.5);
		padding: 0 16px;
		font-weight: 600;
		font-size: 1.1rem;
		border: none;
	}

	tr:nth-child(2n) td {
		background: #f9f9f9;
	}
	td {
		vertical-align: middle;

		&.action-cell {
			text-align: right;
		}
	}
</style>
